import React, {useState} from 'react';
import {CheckoutProvider, PaymentElement, useCheckout} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import {getPublicImagePath, notifyError, notifySuccess} from '@nutastic/nutastic-react-app';
import makeFetchCall from "../../../utils/makeFetchCall";
import {ReactSVG} from "react-svg";
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

const componentClass = 'stripePaymentProcessor'
// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
//TODO: turn this into a configuration
const stripePromise = loadStripe('pk_test_51Re2obRdakmDzecrYScs6Ar0iNN7ht9M7H5Do1NBDbzrrLI47mxUDxwy44Xr7O7tjkaUuSYYQGipVzIX6Oh9MFDZ00AiYCrDzY');

const CheckoutForm = () => {
    const checkout = useCheckout();

    const handleSubmit = async (event) => {
        event.preventDefault();
        console.log('Checkout Items', checkout.lineItems);
        const result = await checkout.confirm();

        if (result.type === 'error') {
            notifyError('paymentNotification', 'Uh Oh, Payment Failed...', 'We were unable to process your payment, please try again.')
            console.log(result.error.message);
        } else {
            console.log('Redirecting now that payment was successful');
        }
    };

    return (
        <form onSubmit={handleSubmit} className="mt-5 mb-5">
            <pre className="d-none">
                {JSON.stringify(checkout.lineItems, null, 2)}
            </pre>
            <h1><b>Total:</b> {checkout.total.total.amount}</h1>
            <PaymentElement />
            <button className="btn btn-block btn-black mt-5">Complete Purchase</button>
        </form>
    );
};

const StripePaymentProcessor = ({ isSubscription, guestEmail, products }) => {
    const [isLoading, setIsLoading] = useState(true);

    const fetchClientSecret = async () => {
        const fetchResult = await makeFetchCall('/api/payments-processor/stripe/create-order', { products, isSubscription, guestEmail });
        setTimeout(() => setIsLoading(false), 250);
        return fetchResult?.checkoutSessionId;
    };

    return <div className={componentClass}>
        { isLoading && <Spin indicator={<LoadingOutlined className="loadingIcon" />} spin={true} className={`${componentClass}__spinner`} /> }
        <CheckoutProvider stripe={stripePromise} options={{ fetchClientSecret }}>
            <CheckoutForm />
        </CheckoutProvider>
    </div>;
};

export default StripePaymentProcessor;
